import { useState } from "react";
import DpsDeltaPage from "./DpsDeltaPage";
import PpdpChangesReviewPage from "./PpdpChangesReviewPage";
import { GitCompare, ClipboardEdit } from "lucide-react";

/**
 * Wrapper Delta DPS→DPSHP + Log Perubahan PPDP dalam 1 halaman dengan 2 tab.
 * Tujuan: konsolidasi 2 menu yang punya audience sama (Admin+Panitia).
 */
export default function DeltaAndLogPage() {
  const [tab, setTab] = useState("delta");

  const tabs = [
    { key: "delta", label: "Ringkasan Delta DPS→DPSHP", icon: GitCompare, sub: "Untuk laporan & cetak BA" },
    { key: "log", label: "Log Perubahan PPDP", icon: ClipboardEdit, sub: "Kontrol harian & tombol Kembalikan" },
  ];

  return (
    <div className="space-y-4" data-testid="delta-and-log-page">
      {/* Top tabs */}
      <div className="border-b border-slate-200">
        <div className="flex gap-1 flex-wrap">
          {tabs.map((t) => {
            const Icon = t.icon;
            const active = tab === t.key;
            return (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                data-testid={`top-tab-${t.key}`}
                className={`flex items-start gap-3 px-4 py-3 border-b-2 -mb-px text-left ${
                  active ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}
              >
                <Icon className={`h-5 w-5 mt-0.5 ${active ? "text-slate-900" : "text-slate-400"}`} />
                <div>
                  <div className="text-sm font-semibold">{t.label}</div>
                  <div className="text-[11px] text-slate-500 font-normal">{t.sub}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      {tab === "delta" && <DpsDeltaPage />}
      {tab === "log" && <PpdpChangesReviewPage />}
    </div>
  );
}
